const divCalendarActionCard = {
  verification: 'Verification',
  equipment: 'Equipment',
  place: 'Place',
  company: 'Company',
  accountable: 'Accountables',
  noAccountable: 'No accountables',
  service: 'Service',
  serviceAction: 'Action created by'
};

export default divCalendarActionCard;
